module.exports = __webpack_public_path__ + "media/bootstrap-icons/fullscreen-exit-e51e6018.svg";